import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../core/modules/common/components/Modal';

const LegendModalThresholdsForCertification = (props) => {
  const {
    closeChart,
  } = props;

  return (
    <div className="chart-modal">
      <Modal
        closeOnOutsideClick
        onClose={closeChart}
      >
        <div className="chart-modal__wrapper" style={{ position: 'relative', height: '200px' }}>
          <div style={{ float: 'left' }}>
            <table>
              <thead><tr>(1) Where the destination operator received PRECON from no more than one operator.</tr></thead>
            </table>
          </div>
          <div style={{ float: 'left', marginTop: '10px' }}>
            <table>
              <thead><tr>(2) In CARDIT: Was CARDIT sent by the operator that sent the PREDES?</tr></thead>
            </table>
          </div>
        </div>
      </Modal>
    </div>
  );
};


LegendModalThresholdsForCertification.propTypes = {
  closeChart: PropTypes.func.isRequired,
};

export default LegendModalThresholdsForCertification;
